const appSettings = {
    development: {
        enableNotifications: true,
        portalDocURL: 'http://localhost:5001',
    },
    production: {
        enableNotifications: true,
        portalDocURL: '',
        isNginx: true,
    },
};

export default appSettings[process.env.NODE_ENV || 'development'];
